export const SLACK_APPSTORE_INSTALL_BUTTON_UTM_TAGS = 'utm_campaign=install&utm_medium=directory&utm_source=slack'